<template>
    <div v-if="overlay" class="overlay">
        <div class="overlay-content">
            <!-- 右上角关闭按钮 -->
            <v-btn 
                icon
                class="close-btn-top-right"
                @click="closeOverlay"
                size="small"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            
            <h3 style="color: white; margin-bottom: 20px;">视频导出进度</h3>
            
            <!-- 创建任务信息 -->
            <div v-if="createMessage" class="message-section">
                <h4 style="color: #4CAF50; margin-bottom: 10px;">任务创建信息</h4>
                <div class="message-content">{{ createMessage }}</div>
            </div>
            
            <!-- 状态信息 -->
            <div v-if="statusMessage" class="message-section">
                <h4 style="color: #2196F3; margin-bottom: 10px;">当前状态</h4>
                <div class="message-content">{{ statusMessage }}</div>
            </div>
            
            <!-- 加载动画 -->
            <div v-if="sliceId && !fileUrl" class="loading-section">
                <div class="loading-spinner"></div>
                <div style="color: white; margin-top: 10px;">处理中，请勿关闭页面...</div>
            </div>
            
            <!-- 按钮区域 -->
            <div class="button-section">
                <v-btn 
                    v-if="fileUrl" 
                    color="success" 
                    @click="downloadFile"
                    class="download-btn"
                >
                    下载视频
                </v-btn>
            </div>
        </div>
    </div>
    <v-container>
        <header>
            <h2>细剪：删字词
                <v-btn style="float: left; background-color: rgb(0, 251, 255); color: white;" @click="jump_to_para_clip">&lt;=粗剪</v-btn>
                <v-btn style="float: right; background-color: rgb(0, 251, 255); color: white;" @click="upload_seg_clip">导出高清</v-btn>
                <!-- <v-btn style="float: right; background-color: rgb(0, 251, 255); color: white;" @click="overlay = !overlay">显示/隐藏字幕</v-btn> -->
                
            </h2>  
        </header>
        
        <v-row class="mt-4 pl-4 pr-4">
                    
                    <v-col cols="4">
                        <video
                            ref="videoPlayer"
                            @timeupdate="updateSubtitle"
                            controls
                            style="width: 100%; max-height: 600px; max-width: 400px;"
                            @play="handlePlay"
                            @pause="handlePause"
                        >
                            <source
                                v-for="(url, index) in video_urls"
                                :key="index"
                                :src="url"
                                type="video/mp4" 
                            >
                        </video>
                        <div style="padding-top: 10px;">
                            <span>总时长：{{ total_time/1000 }}秒</span>
                        </div>
                        <v-btn @click="showInstruction = !showInstruction">
                            用法说明
                            </v-btn>
                        <v-card v-if="showInstruction">
                            本页面用于细剪视频：<br>
                            精修删减字词<br><br>
                            <h5>===用法===</h5><br>
                            拖动鼠标选中想删减的片段<br>
                            del键删选中的字词<br>
                            esc键恢复选中的<br><br>

                            空格控制播放、暂停<br>
                            ctl+左右方向键控制前进、后退<br>
                            
                        </v-card>
                    </v-col>

                    <v-col cols="8" style="overflow-y:auto; height: 100vh; text-align: left; padding-left: 10px;">
                        <div v-for="(spans, index) in json_data_2d" :key="index" style="padding-bottom: 10px; ">
                            <span v-for="w in spans" class='word' :key="w.index_i" :index_w="w.index_w" :index_i="w.index_i" :start_time="w.start_time" :end_time="w.end_time" 
                                    @click="seekTo(w)" :class="{ 'current': w === currentWord, 'deleted': w.deleted,'empty-word': w.text === ''}" 
                                    >{{ w.text || '|空'+((w.end_time-w.start_time)/1000)+'秒|'}}
                            </span>
                        </div>

                    </v-col>
                
        </v-row>
        
    </v-container>
    
</template>

<script>
import { ref, nextTick, computed, onMounted, onBeforeUnmount, h } from 'vue';
import axios from 'axios';
import {useStore} from 'vuex'
import {useRouter} from 'vue-router'
import {BASE_URL} from '@/config.js'
import MessageUtil from '@/utils/MessageUtil';

export default{
    setup(){

        // 先组织数据
        const store = useStore()
        const currentVideo = computed(() => store.state.currentVideo);
        const json_data = computed(() => {
            var segs = store.state.currentTextSpan
            //segs是二维数组，把它转换成一维数组
            var segs_1d = [];
            for (let seg of segs){
                for (let w of seg){
                    segs_1d.push(w);
                }
            }

            for (let i=0; i<segs_1d.length; i++){
                segs_1d[i].index_i = i;
            }
            return segs_1d;
        });
        const total_time = computed(() => {
            var total_time = 0;
            for (let w of json_data.value){
                if (!w.deleted){
                    total_time += w.end_time - w.start_time;
                }
            }
            return total_time;
        });
        const json_data_2d = computed(() => store.state.currentTextSpan)
        // const video_urls = ref(selectedVideo.value.urls)
        const video_urls = computed(() => {
            var urls = [];
            if (!currentVideo.value) return urls;
            if (!currentVideo.value.urls) return urls;
            for (let url of currentVideo.value.urls){
                urls.push(url);
            }
            return urls;
        })
        

        const groupedData = computed(() => {
            let groups = {};
            json_data.value.forEach(item => {                
                if (!groups[item.index_p]) groups[item.index_p] = {};
                if (!groups[item.index_p][item.index_s]) groups[item.index_p][item.index_s] = [];
                groups[item.index_p][item.index_s].push(item);
                });
            return groups;
        });

        onMounted(async () => {
            //把数据从sessionStorage中取出来, commit到store中
            var currentVideo = JSON.parse(sessionStorage.getItem('currentVideo'));
            if (currentVideo){
                store.commit('setCurrentVideo', currentVideo);
            }
            var currentTextSpan = JSON.parse(sessionStorage.getItem('currentTextSpan'));
            if (currentTextSpan){
                store.commit('setCurrentTextSpan', currentTextSpan);
            }

            nextTick(() => {
                

                // 从json_data中找到第一个没有被删除的字，让视频跳到这个字的开始时间
                for (let w of json_data.value){
                    if (!w.deleted){
                        seekTo(w);
                        break;
                    }
                } 
            })
            
                       

            window.addEventListener('keydown', handleKeyDown);
        })

        onBeforeUnmount(() => {
            window.removeEventListener('keydown', handleKeyDown);
            stopPolling(); // 清理前台轮询定时器
            stopBackgroundPolling(); // 清理后台轮询定时器
        })

        const videoPlayer = ref(null);
        const currentWord = ref(null);
        
        const seekTo = (word) => {
            if (videoPlayer.value) {
                // console.log(word);
                videoPlayer.value.currentTime = word.start_time / 1000; // 将毫秒转换为秒
                currentWord.value = word;
            }
        }

        let isPlaying = false; // 用于跟踪视频是否正在播放
        const updateCurrentTime = () => {
                if (!isPlaying) return; // 如果视频不再播放，则停止更新currentTime
                updateSubtitle();
                requestAnimationFrame(updateCurrentTime); // 使用requestAnimationFrame来周期性地更新视频的currentTime
            };

        const handlePlay = () => {   
            isPlaying = true; // 更新isPlaying的值         
            updateCurrentTime();
        };
        const handlePause = () => {
            isPlaying = false; // 更新isPlaying的值
        };

        const find_next_word = (index_i) => {
            var next_word = null;
            for (let i = index_i+1; i<json_data.value.length; i++){
                if (json_data.value[i].deleted){
                    continue;
                }
                if (json_data.value[i].start_time == json_data.value[i].end_time){
                    continue;
                }
                next_word = json_data.value[i];
                break;
            }
            return next_word;
        }

        const has_gap = (currentWord, next_word) => {
            //判断currentWord和next_word之间有没有空隙
            //如果有空隙，返回true，否则返回false
            var has_gap = false;
            if (currentWord.index_w+1 == next_word.index_w){
                return false;
            }

            if (currentWord.index_w > next_word.index_w){
                // 说明下一个字是取了前面的段落
                return true;
            }

            for (let i = currentWord.index_i+1; i<=next_word.index_i; i++){
                var v = json_data.value[i]
                if (v.start_time == v.end_time){
                    continue;
                }
                if (v.deleted){
                    has_gap = true;
                    break;
                }
                if (v.index_w-1 != json_data.value[i-1].index_w){
                    has_gap = true;
                    break;
                }                    
            }
            return has_gap;
        }

        const time_last = ref(null);
        const global_find_current_word = (aim_time) => {
            // 从json_data中找到与currentTime匹配的word
            // 如果找到了，就返回这个word
            // 如果找不到，就返回null
            var currentWord = null;
            for (let i = 0; i<json_data.value.length-1; i++){
                if (json_data.value[i].start_time <= aim_time && json_data.value[i].end_time >= aim_time){
                currentWord = json_data.value[i];
                break;
                }
                if (json_data.value[i].start_time <= aim_time && aim_time < json_data.value[i+1].start_time){
                currentWord = json_data.value[i];
                break;
                }
            }
            if (!currentWord){
                // 说明aim_time在最后一个word的时间范围内
                if (json_data.value[json_data.value.length-1].start_time <= aim_time && aim_time <= json_data.value[json_data.value.length-1].end_time){
                currentWord = json_data.value[json_data.value.length-1];
                }
            }
            return currentWord;
        }
        const updateSubtitle = () => {
            // 这个函数的目的是用尽可能少的开销，来找到当前的currentWord，及做合适的跳转
            // 用到的输入变量： currentTime
            // 通过currentTime去查找currentWord，找到对的currentWord
            // 判断要不要跳转。预计要跳转的情况有：当前时间没有对应的currentWord快燃尽了。就要跳转
            if (!videoPlayer.value) return;
            if (!videoPlayer.value.currentTime) return;
            if (!currentWord.value){
                seekTo(currentWord.value);
                return
            }


            const currentTime = videoPlayer.value.currentTime*1000;
            // 打印一下当前时间
            // if (time_last.value){
                // console.log('diff:', currentTime-time_last.value);
            // }
            time_last.value = currentTime;

            // 找到对的currentWord。先用currentTime找到currentWord
            if (currentWord.value.start_time <= currentTime && currentWord.value.end_time >= currentTime){
                // do nothing 因为当前时间在currentWord的时间范围内                   
            }else{
                // 说明当前时间不在currentWord的时间范围内，需要重新找currentWord
                // 从i位置开始找，在json_data中找到第一个start_time<=currentTime<=end_time的word
                let from_i = currentWord.value.index_i+1
                // this.currentWord = null;
                let found_new_current_time = false;
                for (let i = from_i; i<json_data.value.length; i++){
                if (json_data.value[i].start_time <= currentTime && json_data.value[i].end_time >= currentTime){
                    currentWord.value = json_data.value[i];
                    found_new_current_time = true;
                    break;
                }
                if (json_data.value[i].start_time > currentTime && currentTime > currentWord.value.end_time){
                    //说明已经找到了下一个字，但是当前时间还是不在这个字的时间范围内
                    found_new_current_time = true;
                    break;
                }
                }

                if (!found_new_current_time){
                    // 说明可能匹配的词在前头，从头开始找
                    // 定义一个函数，找到与当前时间匹配的word
                    // todo
                    let new_current_time = global_find_current_word(currentTime);
                    if (new_current_time){
                        currentWord.value = new_current_time;
                        found_new_current_time = true;
                    }
                }

                //实在找不到合适的currentWord，就停止播放
                if (!found_new_current_time){
                    videoPlayer.value.pause();
                    return;
                }
            }

            // 判断要不要停止播放。如果找不到合适的currentWord，就停止播放
            if (!currentWord.value){
                // 说明已经到了最后一个字，停止播放
                videoPlayer.value.pause();
                return;
            }
            

            // 判断要不要跳转
            // 1、currenTime依然不在currentWord的时间范围内，说明要跳转
            if (currentWord.value.start_time > currentTime){
                seekTo(currentWord.value);
                return;
            }   

            // 2、currentTime在currentWord的时间范围内，但是currentWord快燃尽了。可能要跳转
            if (currentWord.value.end_time - currentTime < 80){
                // 说明currentWord快燃尽了，要跳转
                // 从json_data中找到下一个word
                
                var next_word = find_next_word(currentWord.value.index_i);

                //1)有没有next_word
                if(next_word == null){
                    //说明已经到了最后一个字，停止播放
                    videoPlayer.value.pause();
                    return;
                }

                //2)next_word和currentWord之间有没有空隙。怎么判断有没有空隙呢？
                if (has_gap(currentWord.value, next_word)){
                    //说明中间有空隙，要跳转
                    // 但是，如果当前时间已经超过了next_word的start_time，就不跳转了
                    if (currentTime < next_word.start_time || currentTime > next_word.end_time){
                        seekTo(next_word);
                    }
                }
                
            }
            
        }

        const updateSubtitle_old = () => {
            if (!videoPlayer.value) return;
            if (!videoPlayer.value.currentTime) return;
            const currentTime = videoPlayer.value.currentTime*1000;
            
            if (currentWord.value){                
                
                    
                if (currentTime> currentWord.value.end_time-80 || currentTime < currentWord.value.start_time){
                    
                    //说明已经快要跳出上一个字的时间范围或者还没到当前字的时间范围。意味着要跳转。
                    
                    //写一个while循环，找next_word，要跳过start_time和end_time相同的字
                    var i = currentWord.value.index_i;

                    //从json_data取出要跳转到的位置
                    var jump2word = null;
                    var need_jump = false; // 用于标记是否需要跳到jump2word的开始时间
                    
                    
                    if (currentTime < currentWord.value.start_time){
                        need_jump = true;
                        jump2word = currentWord.value;
                    }else{
                        i += 1;
                        if (i<json_data.value.length){
                            jump2word = json_data.value[i];                        
                        }
                    }

                    if (jump2word == null){
                        // 已经到了剪辑的最后一个字，停止播放
                        videoPlayer.value.pause();
                        return
                    }     
                    if (jump2word.index_w-1!=currentWord.value.index_w){
                        //说明中间有切掉一段，需要跳到下一个字的开始时间
                        need_jump = true;
                    }
                                 
                    
                    while (jump2word.start_time == jump2word.end_time){
                        i += 1;
                        if (i < json_data.value.length){
                            jump2word = json_data.value[i];
                            if (jump2word.index_w-1!=json_data.value[i-1].index_w){
                                //说明中间有切掉一段，需要跳到下一个字的开始时间
                                need_jump = true;
                            }
                        }else{
                            jump2word = null;
                            break;  
                        }
                    }

                    if (jump2word == null){
                        // 已经到了剪辑的最后一个字，停止播放
                        videoPlayer.value.pause();
                        return
                    }     

                    

                    // console.log('updateSubtitle', currentTime, need_jump, currentWord.value, next_word, need_jump);
                                    
                    
                    if (!jump2word.deleted){  //这边修改正常播放情况下的currentWord值
                        if (jump2word.start_time <= currentTime && jump2word.end_time >= currentTime){
                                currentWord.value = jump2word;
                                return; 
                            }
                        else if(currentTime<jump2word.start_time && !need_jump){
                            return  //字和字之间有空隙，继续播放
                        }
                    }else{
                        need_jump = true;
                        //这里修改next_word的值。如果下一个字被删除了，就找下一个没有被删除的字
                        while (jump2word.deleted){
                                if (jump2word.index_i+1 < json_data.value.length){
                                    jump2word = json_data.value[jump2word.index_i+1];                        
                                }else{
                                    jump2word = null;
                                    break;
                                }
                            }                                        
                    }

                    if (jump2word == null){
                        // 已经到了剪辑的最后一个字，停止播放
                        videoPlayer.value.pause();
                        return
                    }

                    

                    if (need_jump){
                        //让视频跳到下一个字的开始时间
                        if (!jump2word.deleted){
                            seekTo(jump2word);

                            // videoPlayer.value.play();
                            return;
                        }
                    }
                    
                }            
            }else{

                //最后做一个保稳的操作,防止视频播放过快，跳过了下一个字的开始时间
                for (let w of json_data.value){
                        if (w.start_time <= currentTime && w.end_time >= currentTime){
                                currentWord.value = w;
                                break;
                            }
                    }
            }
        }

        // const updateSubtitle = () => {
        //     if (!videoPlayer.value || !videoPlayer.value.currentTime) return;
        //     const currentTime = videoPlayer.value.currentTime * 1000;
        //     const words = json_data.value;

        //     // 没有当前单词时，就从头找起
        //     if (!currentWord.value) {
        //         currentWord.value = words.find(word => 
        //             !word.deleted && currentTime >= word.start_time && currentTime < word.end_time);
                
        //         // 如果没有找到合适的单词，说明视频结束，暂停播放
        //         if (!currentWord.value) videoPlayer.value.pause();
        //         return;
        //     }

        //     // 判断当前时间是否在当前单词的时间范围内
        //     if (currentTime >= currentWord.value.start_time && currentTime <= currentWord.value.end_time) {
        //         // 当前时间仍然在单词的显示时间内，无需操作
        //         return;
        //     }

        //     // 查找下一个需要显示的单词
        //     let nextIndex = words.findIndex((word, index) => 
        //         index > currentWord.value.index_i && !word.deleted && word.start_time != word.end_time);

        //     // 如果没有找到下一个单词，说明视频结束，暂停播放
        //     if (nextIndex === -1) {
        //         videoPlayer.value.pause();
        //         return;
        //     }

        //     let nextWord = words[nextIndex];

        //     // 如果下一个单词与当前单词之间有间隔（通过index_w判断）
        //     // 或者当前时间已经超出下一个单词的开始时间，则需要跳转
        //     if (nextWord.index_w !== currentWord.value.index_w + 1 && currentTime < nextWord.start_time) {
        //         seekTo(nextWord); // 跳转至下一个单词的开始时间
        //     }
            
        //     // 更新当前单词为下一个单词
        //     currentWord.value = nextWord;
        // };



        
        const handleKeyDown = (event) => {
            //空格键控制播放暂停
            if (event.keyCode === 32) {
                event.preventDefault();
                if (videoPlayer.value.paused) {
                    videoPlayer.value.play();
                } else {
                    videoPlayer.value.pause();
                }
                return;
            }

                        

            //下面是操作部分
            //如果是按backspace键或者del键，则把选中的字幕加上删除线，并从json_data中加上删除标记
            

            //如果按的是del键，则把选中的字幕加上删除线，并从json_data中加上删除标记
            if (event.keyCode === 46 || event.keyCode === 8) {
                // event.preventDefault();                
                if (window.getSelection){
                    let from_span = window.getSelection().anchorNode.parentNode;
                    let end_span = window.getSelection().focusNode.parentNode;
                    // if (from_span != end_span){
                        let from_word = {'index_i':parseFloat(from_span.getAttribute('index_i'))};
                        let end_word = {'index_i':parseFloat(end_span.getAttribute('index_i'))};
                        
                        if (from_word.index_i > end_word.index_i) {
                            let temp = from_word;
                            from_word = end_word;
                            end_word = temp;
                        }

                        //把from_word, end_word中间的值加上删除标记
                        for (let w of json_data.value){
                            if (w.index_i >= from_word.index_i && w.index_i <= end_word.index_i){
                                w.deleted = true;
                            }
                        }                        
                    // }
                }
            }

            //如果按的是ESC键，则把选中的字幕去掉删除线，并从json_data中去掉删除标记
            if (event.keyCode === 27) {
                // event.preventDefault();                
                if (window.getSelection){
                    let from_span = window.getSelection().anchorNode.parentNode;
                    let end_span = window.getSelection().focusNode.parentNode;
                    // if (from_span != end_span){
                        let from_word = {'index_i':parseFloat(from_span.getAttribute('index_i'))};
                        let end_word = {'index_i':parseFloat(end_span.getAttribute('index_i'))};
                        
                        if (from_word.index_i > end_word.index_i) {
                            let temp = from_word;
                            from_word = end_word;
                            end_word = temp;
                        }

                        //把from_word, end_word中间的值去掉删除标记
                        for (let w of json_data.value){
                            if (w.index_i >= from_word.index_i && w.index_i <= end_word.index_i){
                                w.deleted = false;
                            }
                        }                        
                    // }
                }
            }

            //保存到vuex
            store.commit('setCurrentTextSpan', json_data_2d.value);
            sessionStorage.setItem('currentTextSpan', JSON.stringify(json_data_2d.value));
           
        }

        const router = useRouter()

        const jump_to_para_clip = () => {
            store.commit('setCurrentTextSpan', json_data_2d.value);
            sessionStorage.setItem('currentTextSpan', JSON.stringify(json_data_2d.value));
            router.push('para')
        }

        const upload_seg_clip = () => {
            
            const url = BASE_URL+'create_slice/';
            // 优化方案：把连续未删除的字幕合并为 Range 结构，减少请求体积
            var to_clip_array = [];
            let currentRange = null;

            for (let w of json_data.value) {
                if (!w.deleted) {
                    if (currentRange && w.index_w === currentRange.end_index_w + 1) {
                        // 连续，扩展当前范围
                        currentRange.end_time = w.end_time;
                        currentRange.end_index_w = w.index_w;
                        currentRange.text += w.text;
                    } else {
                        // 不连续，先推入上一个 Range，再开启新 Range
                        if (currentRange) {
                            to_clip_array.push(currentRange);
                        }
                        currentRange = {
                            text: w.text,
                            start_time: w.start_time,
                            end_time: w.end_time,
                            start_index_w: w.index_w,
                            end_index_w: w.index_w,
                            index_s: w.index_s,
                            index_p: w.index_p,
                            deleted: false
                        };
                    }
                } else {
                    // 已删除，结束当前 Range
                    if (currentRange) {
                        to_clip_array.push(currentRange);
                        currentRange = null;
                    }
                }
            }
            if (currentRange) {
                to_clip_array.push(currentRange);
            }

            var param = {
                'video_id': currentVideo.value.video_id,
                'transcription_id': currentVideo.value.transcription_id,
                'to_clip_array': to_clip_array,
                'wait_for_result': false  // 设置为异步模式
            }
            
            //展示一个等待图标
            overlay.value = true;
            sliceId.value = null;
            createMessage.value = '';
            statusMessage.value = '';
            fileUrl.value = '';
            
            axios.post(url, param)
                .then(response => {
                    // 获取创建任务的信息
                    createMessage.value = response.message;
                    
                    // 检查是否直接返回了文件URL（重复内容的情况）
                    if (response.file_url) {
                        // 直接使用已有文件，不需要轮询
                        fileUrl.value = response.file_url;
                        statusMessage.value = '文件已准备就绪，可以下载！';
                    } else if (response.slice_id) {
                        // 正常的异步处理流程
                        sliceId.value = response.slice_id;
                        // 开始轮询状态
                        startPolling();
                    }
                })
                .catch(error => {
                    overlay.value = false;
                    MessageUtil.handleApiError(error, '请求失败');
                });
        }

        const overlay = ref(false);
        const showInstruction = ref(false);
        
        // 异步轮询相关变量
        const sliceId = ref(null);
        const createMessage = ref('');
        const statusMessage = ref('');
        const fileUrl = ref('');
        const pollingTimer = ref(null);
        const backgroundPollingTimer = ref(null);  // 后台轮询定时器
        const backgroundTaskId = ref(null);        // 后台任务ID
        
        // 轮询状态的函数（前台显示）
        const startPolling = () => {
            if (!sliceId.value) return;
            
            pollingTimer.value = setInterval(async () => {
                await checkTaskStatus(sliceId.value, false);
            }, 5000); // 每5秒轮询一次
        };
        
        // 开始后台轮询
        const startBackgroundPolling = (taskId) => {
            if (!taskId) return;
            
            backgroundTaskId.value = taskId;
            backgroundPollingTimer.value = setInterval(async () => {
                await checkTaskStatus(taskId, true);
            }, 5000); // 每5秒轮询一次
        };
        
        // 检查任务状态的通用函数
        const checkTaskStatus = async (taskId, isBackground) => {
            try {
                const statusUrl = BASE_URL + `slice_status/${taskId}`;
                const response = await axios.get(statusUrl);
                const data = response;
                
                const status = data.status;
                const errorMessage = data.error_message;
                
                if (status === 'pending') {
                    if (!isBackground) {
                        statusMessage.value = '任务排队中，请稍候...';
                    }
                } else if (status === 'processing') {
                    if (!isBackground) {
                        statusMessage.value = '正在处理中，请稍候...';
                    }
                } else if (status === 'completed') {
                    // 任务完成
                    if (isBackground) {
                        // 后台任务完成，弹出下载窗口
                        stopBackgroundPolling();
                        showDownloadDialog(data.file_url, '导出完成！点击下载视频文件。');
                    } else {
                        // 前台任务完成
                        statusMessage.value = '处理完成！';
                        fileUrl.value = data.file_url;
                        stopPolling();
                    }
                } else if (status === 'failed') {
                    // 任务失败
                    const failureMessage = '处理失败：' + (errorMessage || '未知错误');
                    if (isBackground) {
                        // 后台任务失败，弹出错误提示
                        stopBackgroundPolling();
                        alert(failureMessage);
                    } else {
                        // 前台任务失败
                        statusMessage.value = failureMessage;
                        stopPolling();
                    }
                }
            } catch (error) {
                console.error('轮询状态失败:', error);
                if (!isBackground) {
                    statusMessage.value = '获取状态失败，请稍后重试';
                }
            }
        };
        
        // 停止前台轮询
        const stopPolling = () => {
            if (pollingTimer.value) {
                clearInterval(pollingTimer.value);
                pollingTimer.value = null;
            }
        };
        
        // 停止后台轮询
        const stopBackgroundPolling = () => {
            if (backgroundPollingTimer.value) {
                clearInterval(backgroundPollingTimer.value);
                backgroundPollingTimer.value = null;
            }
            backgroundTaskId.value = null;
        };
        
        // 显示下载对话框
        const showDownloadDialog = (downloadUrl, message) => {
            // 重新打开遮罩显示下载界面
            overlay.value = true;
            createMessage.value = '';
            statusMessage.value = message;
            fileUrl.value = downloadUrl;
            sliceId.value = null; // 清空任务ID，避免显示加载动画
        };
        
        // 下载文件
        const downloadFile = () => {
            if (!fileUrl.value) return;
            
            const downloadLink = document.createElement('a');
            downloadLink.href = fileUrl.value;
            downloadLink.setAttribute('download', '');
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
            
            // 下载完成后关闭遮罩
            closeOverlay();
        };
        
        // 关闭遮罩
        const closeOverlay = () => {
            overlay.value = false;
            
            // 如果有正在进行的任务，转为后台轮询
            if (sliceId.value && !fileUrl.value) {
                stopPolling(); // 停止前台轮询
                startBackgroundPolling(sliceId.value); // 开始后台轮询
                
                // 提示用户任务在后台继续
                alert('导出任务将在后台继续进行，完成后会自动弹出下载窗口。');
            } else {
                // 没有任务或任务已完成，完全清理
                stopPolling();
                stopBackgroundPolling();
            }
            
            // 清理界面状态
            sliceId.value = null;
            createMessage.value = '';
            statusMessage.value = '';
            fileUrl.value = '';
        };

        return {
            json_data,
            json_data_2d,
            total_time,
            groupedData,
            videoPlayer,
            handleKeyDown,
            seekTo,
            currentWord,
            handlePlay,
            handlePause,
            upload_seg_clip,
            jump_to_para_clip,
            video_urls,
            overlay,
            showInstruction,
            sliceId,
            createMessage,
            statusMessage,
            fileUrl,
            downloadFile,
            closeOverlay
        }

    }
}

</script>

<style scoped>
    .current {
        background-color: red;
        color: white;
    }

    .deleted {
        text-decoration: line-through;
        background-color: lightgray;
        color: gray;
    }

    .empty-word {
        font-size: small;
        background-color: silver;
        color: white;
        border-radius: 5px;
        padding: 2px;
    }
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 9999;
    }
    
    .overlay-content {
        background-color: #2c3e50;
        border-radius: 10px;
        padding: 30px;
        max-width: 500px;
        min-width: 400px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
        text-align: center;
        position: relative;
    }
    
    .close-btn-top-right {
        position: absolute !important;
        top: 10px !important;
        right: 10px !important;
        background-color: rgba(255, 255, 255, 0.2) !important;
        color: white !important;
    }
    
    .close-btn-top-right:hover {
        background-color: rgba(255, 255, 255, 0.3) !important;
    }
    
    .message-section {
        margin-bottom: 20px;
        padding: 15px;
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: 8px;
        text-align: left;
    }
    
    .message-content {
        color: white;
        line-height: 1.6;
        white-space: pre-line;
    }
    
    .loading-section {
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    
    .loading-spinner {
        width: 40px;
        height: 40px;
        border: 4px solid rgba(255, 255, 255, 0.3);
        border-top: 4px solid #3498db;
        border-radius: 50%;
        animation: spin 1s linear infinite;
    }
    
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
    
    .button-section {
        margin-top: 25px;
        display: flex;
        gap: 15px;
        justify-content: center;
    }
    
    .download-btn {
        font-size: 16px !important;
    }

</style>
